/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

export function useUsuariosEquipe(idUsuario: string, enabled?: boolean) {
  const fetchData = async () => {
    if (idUsuario === undefined) {
      return;
    }
    const USUARIOS_EQUIPE = `identity/admin/hierarquias/usuarios-equipe-por-lider/v1/${idUsuario}`;
    const response = await instance.get(USUARIOS_EQUIPE);
    return response?.data?.data;
  };
  const query = useQuery({
    queryFn: async () => await fetchData(),
    queryKey: ["usuariosequipe"],
    refetchOnWindowFocus: false,
    enabled: enabled === undefined ? true : enabled,
  });
  return query;
}
